// `./contracts` — query-key registry for the commerce domain (arch §5.1).
// Key strings are FROZEN verbatim from their pre-move definitions: renaming a
// key orphans every user's cached entry. Importable by any DAG-compatible
// consumer, incl. foreign `data/` layers (Aperture 1).
//
// The spellings below are deliberately heterogeneous — three different
// conventions across six keys (a path-like literal, a SCREAMING_CASE literal,
// a camelCase literal, a snake_case literal). That is exactly why they are
// frozen rather than normalised: each string is a live cache identity, and
// "tidying" one would silently orphan the entries it addresses.

/** GET /products — query keys are `[GET_PRODUCTS, 'v2' | 'v3']` so `[GET_PRODUCTS]` still invalidates both. */
export const GET_PRODUCTS = '/api/v2/products';

/** Add-on catalog — moved verbatim from `useQueryAddOnProduct.ts`. */
export const GET_ADD_ON_PRODUCTS = '/products/add-on-products';

/** Team billing details — moved verbatim from `useQueryTeamBilling.ts`. */
export const GET_TEAM_BILLING_DETAILS = 'GET_TEAM_BILLING_DETAILS';

/** User billing info — moved verbatim from `useQueryUserBillingInfo.ts`. */
export const GET_USER_BILLING_INFO = 'getUserBillingInfo';

/** User add-on billing info — moved verbatim from `useQueryUserAddOnBillingInfo.ts`. */
export const GET_USER_ADD_ON_PRODUCT_BILLING_INFO = `/billings/add-on-products`;

/** Gamify trial extension — moved verbatim from `useQueryGamifyTrialExtension.ts`. */
export const GET_GAMIFY_TRIAL_EXTENSION = 'get_gamify_trial_extension';

/** Current credit allowance */
export const GET_CREDIT_ALLOWANCE = '/credit-allowance';

/** GET /credit-allowance/workspaces/{workspace_id}/members — every member's seat, keyed by workspace. */
export const GET_WORKSPACE_MEMBER_CREDIT_ALLOWANCES =
  '/credit-allowance/workspaces/members';

/** POST /billings/request-heidi-2-access — a mutation identity, not a cache entry. */
export const REQUEST_HEIDI_2_ACCESS_MUTATION_KEY = 'requestHeidi2Access';

/** POST /billings/team-upgrade-intent/preview — cached by price and selected members. */
export const GET_HEIDI_2_UPGRADE_PREVIEW = 'heidi2UpgradePreview';

/** GET /billings/team-upgrade-intent — the workspace's pending and upgraded members. */
export const GET_TEAM_UPGRADE_INTENT = 'teamUpgradeIntent';
